import { Box } from '@mui/material'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'
import {
  SheduleTableProps,
  SchedulerKitchenCycleRowType,
} from './Scheduler.types'
import { KITCHEN_CYCLE_COLUMNS } from './SOR/SORTableColumns'

/**
 * Kitchen cycles — `KitchenCyclesDelta`.
 *
 * One row per base material in a kitchen's cycle. The engine pins each one to
 * that kitchen, gives each week's demand for it its own batch, and runs the
 * batches in position order, week after week. The base material keys the
 * row, because a base can be in only one cycle.
 */
const dataConfig = {
  required: ['kitchen', 'baseMaterialCode', 'position'],
  optional: [],
}

// Read-only here: a cycle is authored through the kitchen popup on the page,
// which keeps each kitchen's positions consistent. Delete still works.
const columns = KITCHEN_CYCLE_COLUMNS.map((c) => ({
  ...c,
  editable: false,
})) as ExtendedGridColDef[]

export const SchedulerKitchenCyclesTable = ({
  data,
  isLoading,
  updateTableData,
  uploadScheduleData,
  isUploading,
  isSaving,
  updateRowsStatus,
  predicate,
  deleteTableData,
  isDeleting,
}: SheduleTableProps<SchedulerKitchenCycleRowType>) => (
  <Box>
    <BaseTable
      data={data ?? []}
      columns={columns}
      isLoading={isLoading}
      updateTableData={updateTableData}
      uploadData={uploadScheduleData}
      isUploading={isUploading}
      isSaving={isSaving}
      checkBoxSelection={true}
      showTableToolBar={true}
      downloadFileName="SchedulerKitchenCycles"
      onDeleteRows={deleteTableData}
      isDeleting={isDeleting}
      multiStageUpload={{
        uploadFile: uploadScheduleData,
        isUploading: isUploading,
        columns: columns,
        updateRowsStatus: updateRowsStatus,
        originalData: data,
        predicate: predicate,
        dataConfig: dataConfig,
      }}
      initialState={{
        pagination: { paginationModel: { pageSize: 100 } },
      }}
      sx={{
        maxWidth: 'calc(100vw - 70px)',
        '& .MuiDataGrid-cell--editable': {
          backgroundColor: '#CBD5E1',
        },
        '& .MuiBox-root': {
          padding: '0px !important',
        },
      }}
    />
  </Box>
)
